import ClientAnalyticsPage from './ClientAnalyticsPage';

export default ClientAnalyticsPage;
